import React from 'react';

const OfferDetails = ({ offerDetails }) => {
  return (
    <div className="bg-white p-6 rounded-xl flex flex-col gap-4">
      <h4>Πληροφορίες Προσφοράς</h4>
      <ul className="flex flex-col gap-4">
        {Object.keys(offerDetails).map((key) => {
          const { id, label, value } = offerDetails[key];
          return (
            <li
              key={id}
              className="flex max-lg:flex-col lg:justify-between flex-1"
            >
              <span className="text-body text-grenite">{label}</span>
              <span className="max-lg:font-medium max-lg:h5 h6">{value}</span>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default OfferDetails;
